﻿import React from 'react';

// lib 
import { motion, AnimatePresence } from 'framer-motion';
import Lottie from 'lottie-react';


import heartAnimationData from '../AnimationFiles/breath.json';

const HeartLoaderModal = (props) => {

    return (
        <AnimatePresence>
            <motion.div
                className="heart-loader__modal"
                initial={{
                    opacity: 0,
                    scale: 0.75,
                }}
                animate={{
                    opacity: 1,
                    scale: 1,
                    transition: {
                        ease: "easeOut",
                        duration: 0.15,
                    },
                }}
                exit={{
                    opacity: 0,
                    scale: 0.75,
                    transition: {
                        ease: "easeIn",
                        duration: 0.15,
                    },
                }}
            >
               <div className="heart-loader">
                    <Lottie
                        className="heart-loader__animation"
                        autoplay={true}
                        loop={true}
                        animationData={heartAnimationData}
                    />
                    {props.text && <p>{props.text}</p>}
                </div>
            
            </motion.div>
        </AnimatePresence>
    )
}

export default HeartLoaderModal;